import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import { OrganicMatterBenchmark, OrganicMatterReport } from '../organic-matter-balance.models';

@Injectable({
  providedIn: 'root',
})
export class OrganicMatterService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/environmental-metric-service';

  fetchOrganicMatterBenchmark(cropYear: number): Observable<OrganicMatterBenchmark> {
    return this.http.get<OrganicMatterBenchmark>(`${this.baseUrl}/organicmatterbenchmark/${cropYear}`);
  }

  fetchOrganicMatterBalanceReport(cropYear: number): Observable<OrganicMatterReport> {
    return this.http.get<OrganicMatterReport>(`${this.baseUrl}/organicmatterbalance/${cropYear}`);
  }
}
